import React, { Component } from "react";
import styles from "./SlideCompositionPage.local.scss";
import Select from "react-select";
import { connect } from "react-redux";
import { addNumberOfYears, addAnnexeCategory } from "Actions";
class SelectCategory extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption: null
    };
  }
  handleChange = selectedOption => {
    const { componentConfig, dispatch } = this.props;
    if (selectedOption) {
      this.setState({ selectedOption: selectedOption });
      this.props.HandleSelectAnnexeCategory(
        selectedOption.value,
        this.props.isBarometer,
        this.props.isTable
      );
    } else {
      componentConfig.config.hasOwnProperty("annexeAttachmentCategory") &&
        delete componentConfig.config["annexeAttachmentCategory"];
      dispatch(addNumberOfYears(componentConfig.config));
      dispatch(addAnnexeCategory(null));
      this.setState({ selectedOption: null });
    }
  };
  render() {
    const { selectedOption } = this.state;
    const { annexeCategories, lng } = this.props;
    const options =
      annexeCategories &&
      annexeCategories.map(category => {
        return { label: category.label[lng], value: category.id };
      });
    let updatedCategory = "";
    if (this.props.categoryUpdate) {
      // eslint-disable-next-line array-callback-return
      annexeCategories.map(cat => {
        if (cat.id === this.props.categoryUpdate) {
          updatedCategory = cat.label[lng];
        }
      });
    }
    let updated = {
      label: updatedCategory ? updatedCategory : "",
      value: this.props.categoryUpdate
        ? this.props.categoryUpdate[this.props.indicatorNum]
        : ""
    };
    return (
      <Select
        value={
          updated.label && this.props.update === "UPDATE"
            ? updated
            : selectedOption
        }
        // value={selectedOption}
        onChange={this.handleChange}
        options={options}
        className={
          this.props.isSampleConfig
            ? styles.sample_input_category
            : styles.input_category
        }
        classNamePrefix="ttp-select"
        width={"12px"}
        isClearable={true}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetched: state.indicators.fetched,
  suggestions: state.indicators.suggestions.items,
  selectedComponent: state.slideComposition.composition.selectedComponent,
  composition: state.slideComposition.composition,
  update: state.slideComposition.ComponentAction,
  lng: state.params.lng,
  componentConfig: state.slideComposition.componentConfig
});

export default connect(mapStateToProps)(SelectCategory);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/SelectCategory.js